import React from "react";

import { admin_cse } from "@/config/roles";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { getACPStatus } from "@/features/acp/helpers/program-status";
import { getLatestACPConsent } from "@/features/acp/helpers/latest-consent";
import { isAuthorized } from "@/utils/authToken";
import type { PatientConsent, UUID } from "@/core/types";

import { OptOutButton } from "./OptOutButton";
import { SectionDetailList } from "./SectionDetailList";

type MemberProfileACPSectionProps = {
  consents: PatientConsent[];
  insuranceCarrier: string;
  patientId: UUID;
};

export function MemberProfileACPSection({
  consents,
  insuranceCarrier,
  patientId,
}: MemberProfileACPSectionProps) {
  const latestACPConsent = getLatestACPConsent(consents);
  const { consentResponse, responseGivenByName, sortKey } = latestACPConsent || {};

  const consentStatus = getACPStatus({ consentResponse, insuranceCarrier });
  const isCSE = isAuthorized(admin_cse);
  const isOptedIn = consentStatus === "OPTED_IN";
  const isNotResponded = consentStatus === "NOT_RESPONDED";

  const shouldShowOptOutButton = (isOptedIn || isNotResponded) && isCSE;

  return (
    <DashboardCard2
      Actions={
        shouldShowOptOutButton && (
          <OptOutButton patientId={patientId} patientName={responseGivenByName} sortKey={sortKey} />
        )
      }
      title="Advanced Care Program Status"
    >
      <SectionDetailList consent={latestACPConsent} consentStatus={consentStatus} />
    </DashboardCard2>
  );
}
